import React, { useState } from 'react';
import { 
    devClearSubscriptions,
    devClearTrialHistory,
    devClearPaymentHistories
} from '../services/api';

const DevToolsPage = () => {
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');

    const handleAction = async (actionFunction, confirmText, successText) => {
        if (loading) return;
        if (!window.confirm(`【警告】您確定要執行以下操作嗎？\n\n${confirmText}\n\n此操作無法復原！`)) {
            return;
        }

        setLoading(true);
        setMessage('');

        try {
            await actionFunction();
            alert(`${successText}成功！`);
            setMessage(`${successText}已成功。`);
        } catch (err) {
            const errorMessage = err.response?.data?.message || '發生未知錯誤';
            alert(`${successText}失敗：${errorMessage}`);
            setMessage(`${successText}失敗：${errorMessage}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-container">
            <div className="page-header">
                <h2>開發工具</h2>
            </div>
            <div className="dev-tools-panel">
                <div className="warning-box">
                    <strong>注意：</strong> 此頁面中的所有操作都具有**破壞性**，且**無法復原**。僅供開發與測試環境使用。
                </div>

                <div className="actions-container">
                    <div className="action-item">
                        <h4>清除訂閱紀錄</h4>
                        <p>刪除此使用者的所有訂閱紀錄 (包含付費、免費、試用)。</p>
                        <button 
                            className="action-button destructive"
                            disabled={loading}
                            onClick={() => handleAction(
                                devClearSubscriptions,
                                '清除使用者所有訂閱紀錄',
                                '清除訂閱紀錄'
                            )}
                        >
                            {loading ? '處理中...' : '清除訂閱紀錄'}
                        </button>
                    </div>

                    <div className="action-item">
                        <h4>清除試用紀錄</h4>
                        <p>刪除此使用者的試用歷史，讓他可以再次進行試用。</p>
                        <button 
                            className="action-button destructive"
                            disabled={loading}
                            onClick={() => handleAction(
                                devClearTrialHistory,
                                '清除使用者試用紀錄',
                                '清除試用紀錄'
                            )}
                        >
                            {loading ? '處理中...' : '清除試用紀錄'}
                        </button>
                    </div>

                    <div className="action-item">
                        <h4>清除付款紀錄</h4>
                        <p>刪除此使用者的所有付款歷史紀錄。</p>
                        <button 
                            className="action-button destructive"
                            disabled={loading}
                            onClick={() => handleAction(
                                devClearPaymentHistories,
                                '清除使用者付款紀錄',
                                '清除付款紀錄'
                            )}
                        >
                            {loading ? '處理中...' : '清除付款紀錄'}
                        </button>
                    </div>
                </div>

                {message && <div className="feedback-message">{message}</div>}
            </div>
        </div>
    );
};

export default DevToolsPage;